import { render, staticRenderFns } from "./NewBank.vue?vue&type=template&id=3acc05ce&scoped=true"
import script from "./NewBank.vue?vue&type=script&lang=js"
export * from "./NewBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acc05ce",
  null
  
)

export default component.exports